export interface GetInputContentRequest {
    /** 任务ID */
    task_id: string;
}

export interface GetInputContentResponse {
    /** 返回受理局 */
    jurisdiction: string;
    /** 交底书文本 */
    disclosure: string;
    /** 权利要求文本 */
    claim: string;
}

export const GetInputContentApi = Symbol.for('GetInputContentApi');

export interface GetInputContentApi {
    getInputContent(data: GetInputContentRequest): Promise<GetInputContentResponse>;
}
